import type { WorkItem } from "./types";

export const OUT_OF_QUEUE_COMPLETION_MESSAGE =
    "You are not a member of a queue assigned to this task. Are you sure you want to complete it?";

type ConfirmCompletion = (message: string) => boolean;

/**
 * Returns whether completion crosses the task's current responsibility
 * boundary. AwaitingActionByQueueIds is the actionable assignment set;
 * VisibleToQueueIds is intentionally excluded because visibility does not
 * imply that a queue owes work.
 */
export function requiresOutOfQueueCompletionConfirmation(
    workItem: WorkItem,
    memberQueueIds: ReadonlySet<string>,
): boolean {
    return (
        workItem.type === "task" &&
        workItem.awaitingActionByQueueIds.length > 0 &&
        !workItem.awaitingActionByQueueIds.some((queueId) => memberQueueIds.has(queueId))
    );
}

/**
 * Resolves the UI warning while keeping the membership decision independently
 * testable. Legacy tasks without an actionable assignment proceed directly
 * because there is no assigned queue to warn about.
 */
export function confirmOutOfQueueTaskCompletion(
    workItem: WorkItem,
    memberQueueIds: ReadonlySet<string>,
    confirmCompletion: ConfirmCompletion,
): boolean {
    if (!requiresOutOfQueueCompletionConfirmation(workItem, memberQueueIds)) {
        return true;
    }

    return confirmCompletion(OUT_OF_QUEUE_COMPLETION_MESSAGE);
}
